import { useSceneEntities } from "@/stores/SceneEntities";
import { usePresetsBuild } from "@/scripts/rooms/actions/general/PresetsBuild";
export function usePresetDelete(payload, viewport) {
  
  const sceneEntities = useSceneEntities();
  sceneEntities.removePreset(payload);
  sceneEntities.savePresetsPersistant();
  usePresetsBuild();
}
